import { render, staticRenderFns } from "./EstimationDashboard.vue?vue&type=template&id=287e73bf&scoped=true"
import script from "./EstimationDashboard.vue?vue&type=script&lang=js"
export * from "./EstimationDashboard.vue?vue&type=script&lang=js"
import style0 from "./EstimationDashboard.vue?vue&type=style&index=0&id=287e73bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e73bf",
  null
  
)

export default component.exports